<template>
  <div>
    <a-row :gutter="[16,16]">
      <a-tabs :default-active-key="activeEmpKey">
      <a-tab-pane v-if="visibleSeguridadSocial" key="1">
      <span slot="tab">
        <a-icon type="safety-certificate" />
        Seguridad social
      </span>
      <a-col :span="24">
        <a-card>
          <g-master name="OtraInformacionLaboral"
                    :endpoint="seguridadsocmaster.endpoint"
                    :tableSetup="seguridadsocmaster.tableSetup"
                    :modalFieldsSetup="seguridadsocmaster.modalFieldsSetup"
                    :parentData="evParentData"
          >
            <template slot="masterModal" slot-scope="{record}">
              <a-form-item :label="$t('Tipo Entidad')">
                <g-dropdown endpoint="hierarchy_lookup"
                            :selectedObj.sync="tipoentidadSeleccionada"
                            :decorator="['id_h_type_ss', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                            :params="id_h_type_ss">
                </g-dropdown>
              </a-form-item>
              <a-form-item :label="$t('Seguridad social')">
                <g-dropdown endpoint="legal_entities"
                            :decorator="['social_security', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                            :params="seguidadSocialParams">
                </g-dropdown>
              </a-form-item>
            </template>
          </g-master>
        </a-card>
      </a-col>
      </a-tab-pane>
      <a-tab-pane v-if="visibleTallas" key="2">
      <span slot="tab">
        <a-icon type="skin" />
        Tallas
      </span>
      <a-col :span="24">
        <a-card>
          <g-master name="OtraInformacionLaboral"
                    :endpoint="tallassmaster.endpoint"
                    :tableSetup="tallassmaster.tableSetup"
                    :modalFieldsSetup="tallassmaster.modalFieldsSetup"
                    :parentData="evParentData"
          >
            <template slot="masterModal" slot-scope="{record}">
              <a-form-item :label="$t('Tipo de prenda')">
                <g-dropdown endpoint="garment_type"
                            :decorator="['tercero', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                            :selectedObj.sync="talla"
                >
                </g-dropdown>
              </a-form-item>
              <a-form-item :label="$t('Talla')">
                <g-dropdown endpoint="garment_size"
                            :decorator="['garment_size', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                            :params="garmentSizeParams">
                </g-dropdown>
              </a-form-item>
            </template>
          </g-master>
        </a-card>
      </a-col>
      </a-tab-pane>
      <a-tab-pane v-if="visibleMedidas" key="3">
      <span slot="tab">
        <a-icon type="tags" />
        Medidas
      </span>
      <a-col :span="24">
        <a-card>
          <g-master name="OtraInformacionLaboral"
                    :endpoint="medidasmaster.endpoint"
                    :tableSetup="medidasmaster.tableSetup"
                    :modalFieldsSetup="medidasmaster.modalFieldsSetup"
                    :parentData="evParentData"
                    @action="masterAction"
                    ref="masterComponent"
          >
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              :label="'Estatura'"
                              :formItemConfig="fiOptions"
                              :decorator="['unid_height', { rules: [{ required: false }] }]"
                              :params="heigth"
                              ref="unid_height"
                  >
                  </g-dropdown>
                  <a-input-number
                    style="width: 100%;"
                    :disabled="heigth_disabled"
                    v-decorator="['height', { rules: [{ required: false}] }]"/>
                </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="hierarchy_lookup"
                            :label="'Peso'"
                            :formItemConfig="fiOptions"
                            :decorator="['unid_weight', { rules: [{ required: false}] }]"
                            :params="weight">
                </g-dropdown>
                  <a-input
                    style="width: 100%;"
                    :disabled="weight_disabled"
                    v-decorator="['weight', { rules: [{ required: false}] }]"/>

              </a-col>
              </a-row>
            </template>
          </g-master>
        </a-card>
      </a-col>
      </a-tab-pane>
    </a-tabs>
    </a-row>
  </div>
</template>

<script>
  import JsUtils from '@/util/JsUtils'

  export default {
    data () {
      return {
        activeEmpKey: 0,
        fiOptions: {
          'label-col': {span: 3},
          'wrapper-col': {span: 21}
        },
        heigth_disabled: true,
        weight_disabled: true,
        tiposeguridad: {
          id_h_type_ss: {},
          social_security: {}
        },
        id_h_type_ss: {
          h_lookup_type: 'TIPO_ENTIDAD'
        },
        heigth: {
          h_lookup_type: 'MEDIDA_ESTATURA_HV'
        },
        weight: {
          h_lookup_type: 'MEDIDA_PESO_HV'
        },
        colOptions: {xs: 24, sm: 24},
        col2Options: {xs: 24, sm: 12},
        // Master de seguridad social
        seguridadsocmaster: {
          endpoint: 'personss',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_person_ss'
            },
            columns: [
              {title: 'Tipo', dataIndex: 'tipo', sorter: true},
              {title: 'Seguridad social', dataIndex: 'ent_name', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'social_security'},
            {name: 'id_h_type_ss'}
          ]
        },

        // Master de medidas
        medidasmaster: {
          endpoint: 'personmeasure',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_person_measures'
            },
            columns: [
              {title: 'Estatura', dataIndex: 'height', sorter: true},
              {title: 'Unidad de estatura', dataIndex: 'altura', sorter: true},
              {title: 'Peso', dataIndex: 'weight', sorter: true},
              {title: 'Unidad de peso', dataIndex: 'peso', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'height'},
            {name: 'unid_height'},
            {name: 'weight'},
            {name: 'unid_weight'}
          ]
        },
        // Master de tallas
        tallassmaster: {
          endpoint: 'person_endowment',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_endowment'
            },
            columns: [
              {title: 'Tipo de prenda', dataIndex: 'tipo_prenda', sorter: true},
              {title: 'Talla', dataIndex: 'talla', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'garment_size'},
            {name: 'tercero'}
          ]
        },
        tipoentidadSeleccionada: {},
        talla: {}
      }
    },
    props: ['persona'],
    computed: {
      visibleSeguridadSocial () {
        let existeParametro = this.$getConfigValue('PARAMETRIZAR_TABS_HOJA_VIDA')
        if (this.$isEmpty(existeParametro) || existeParametro === 'NO' || this.$userIsInrol('Management')) {
          this.activeEmpKey = 1
          return true
        } else {
          this.activeEmpKey = 1
          return this.$userIsInrol('BIO_SEGURIDAD_SOCIAL')
        }
      },
      visibleTallas () {
        let existeParametro = this.$getConfigValue('PARAMETRIZAR_TABS_HOJA_VIDA')
        if (this.$isEmpty(existeParametro) || existeParametro === 'NO' || this.$userIsInrol('Management')) {
          this.activeEmpKey = 1
          return true
        } else {
          this.activeEmpKey = 2
          return this.$userIsInrol('BIO_TALLAS')
        }
      },
      visibleMedidas () {
        let existeParametro = this.$getConfigValue('PARAMETRIZAR_TABS_HOJA_VIDA')
        if (this.$isEmpty(existeParametro) || existeParametro === 'NO' || this.$userIsInrol('Management')) {
          this.activeEmpKey = 1
          return true
        } else {
          this.activeEmpKey = 3
          return this.$userIsInrol('BIO_MEDIDAS')
        }
      },
      evParentData () {
        return {
          id_person: this.persona
        }
      },
      seguidadSocialParams () {
        return {
          ent_type: (!JsUtils.isEmpty(this.tipoentidadSeleccionada) && !JsUtils.isEmpty(this.tipoentidadSeleccionada.code))
            ? this.tipoentidadSeleccionada.code : -1
        }
      },
      garmentSizeParams () {
        return {
          id_garment_type: (!JsUtils.isEmpty(this.talla) && !JsUtils.isEmpty(this.talla.value))
            ? this.talla.value : -1
        }
      }
    },
    methods: {

      masterAction (action) {
        switch (action.action) {
          case 'masterCreate':
            console.log(this.$refs.unid_height.fiConfig)
            break
          case 'fieldsChange':
            if (Object.keys(action.changedFields).length > 1) {
              break
            }
            if (!JsUtils.isEmpty(action.changedFields.unid_height)) {
              if (!JsUtils.isEmpty(action.changedFields.unid_height.value)) {
                this.heigth_disabled = false
              } else {
                this.heigth_disabled = true
              }
            }
            if (!JsUtils.isEmpty(action.changedFields.unid_weight)) {
              if (!JsUtils.isEmpty(action.changedFields.unid_weight.value)) {
                this.weight_disabled = false
              } else {
                this.weight_disabled = true
              }
            }

            break
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Biodata/BiodataOtraInformacionLaboral.vue